export default {
    consultingServe: '咨询服务',
    regulatoryList: {
        title1: '打击金融犯罪合规',
        list1: {
            content1: '打击金融犯罪合规框架和治理体系，包括反洗钱、发诈骗、内部交易等方面',
            content2: '内部交易及市场操纵监测模型与系统设计，测试与验证',
            content3: '制裁筛查与洗钱交易监控模型及系统的设计、测试与验证',
            content4: '合规审阅、审计与独立测试',
        },
        title2: '隐私与数据保护',
        list2: {
            content1: '隐私合规体系，涵盖信息收集、使用、处理、共享和处置的各个阶段',
            content2: '集团隐私管控水平成熟度评估及整改路线图',
            content3: '欧盟一般数据保护法(GDPR)及美国加州消费者隐私法案(CCPA)等国际隐私保护法规解读、适用性评估及实施落地',
            content4: '重大事件应急响应机制及演练',
        },
        title3: '监管合规和行为',
        list3: {
            content1: '集团合规体系建立及海外机构的合规安排',
            content2: '协助金融机构开展合规定检、降低处罚风险',
            content3: '企业反贿赂和反腐败尽职调查',
            content4: '员工舞弊事实调查，核实员工是否涉嫌舞弊、违规',
        },
        title4: '合规与风险管理培训',
        list4: {
            content1: '协助金融机构制定年度培训计划、年中计划管理和年末完成评价和总结',
            content2: '借助锐课TM培训平台，提供针对高管、合规、业务人员及海外合规/风控人员的年度培训和合规/风险管理主题培训',
        },
    },
    riskManagementServeList: {
        title1: '市场风险管理',
        list1: {
            content1: '市场风险管理体系，包括满足标准法和内部模型法的政策、流程、压力测试方法论、估值和风险计量模型',
            content2: '内部模型法、巴塞尔III标准计量系统，支持多套新旧资本计量标准灵活测算、限额管理应用、压力测试、返回检验等功能，跑批性能显著优于同类产品',
            content3: '估值与巴塞尔III标准法敏感性计量服务'
        },
        title2: '信用风险管理',
        list2: {
            content1: '信用风险管理框架包括政策、流程、限额管理、预警与信贷资产组合优化、压力测试情景',
            content2: 'PD和LGD模型的设计开发、测试，调优与第三方验证',
            content3: '特征变量构建与人工智能技术应用探索',
            content4: '巴塞尔新标准法计量系统，支持多地区多套监管口径资本计量规则灵活配置，跑批性能显著优于同类产品',
        },
        title3: '资产负债类风险管理',
        list3: {
            content1: '中国大陆和香港地区银行账簿利率风险和流动性风险管理，包括政策、流程、发放论和模型(包括压力测试)',
            content2: '用于内部流动性风险计量与监控的端到端、全流程现金流预测工具与系统',
            content3: '银行账簿利率风险标准框架重定价现金流计量及EVE监控指标汇总工具',
            content4: '中国大陆与香港地区监控报表与内部管理报告编报工具和系统',
        },
        title4: '数据与系统',
        list4: {
            content1: '巴塞尔239风险数据合规评估咨询与系统',
            content2: '风险数据集市建设，包括数据模型及需求开发、大数据分析与应用',
            content3: '风险数据标准框架，包括监管数据(EAST)接口开发与检查、数据标准建设指导收集业务与技术需求、协助搭建企业级数据字典、把控关键数据，质量管理的建设实施等',
            content4: '风险报告计量引擎与平台',
        }
    },
    strategyAndOperation: {
        title1: '业务拓展合规咨询',
        list1: {
            content1: '市场评估和战略规划',
            content2: '金融服务牌照要求、反洗钱与制裁、外汇管制、数据隐私、网络安全、消费者保护、风险管理等监管主题调研、规划实施路线图',
        },
        title2: '策略/业务转型咨询',
        list2: {
            content1: '优化业务与合规流程，提升效率',
            content2: '数字化转型战略规划与蓝图设计',
            content3: '合规服务外包，包括但不限于客户尽职调查、可疑交易人工甄别、制裁命中人工甄别、反欺诈调查、模型独立验证等',
        },
    }
}